  <!-- YouTube video player -->
  @if (isExternalVideo(section)) {
    @if (youTubeVideoId$ | async; as videoId) {
      @if ((userConsent.given$ | async) === false) {
        <img class="youtube-thumbnail"
          [src]="youTubeThumbnailUrl$ | async"
          alt=""
          loading="lazy"
        >
        <app-user-consent-dialog [consent]="userConsent">
          <ng-container slot="title" i18n="YouTube GDPR consent title@@5925881507551885808">Data transmission to YouTube</ng-container>
          <ng-container i18n="YouTube GDPR consent body@@6332247001604089884">
            This video is embedded on our website via YouTube.<br>
            Data is only transmitted to YouTube when you click on “Agree”.<br>
            Please refer to <a kb-link href="https://www.youtube.com/t/privacy" target="_blank">the privacy policy of YouTube</a> for more details.
          </ng-container>
        </app-user-consent-dialog>
      } @else {
        <iframe [src]="getYouTubeEmbedUrl(videoId) + '?modestbranding=1&autohide=1&showinfo=0&controls=1'| safe: 'resourceUrl'"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          [appEditorId]="section.editorIds?.embedUrl"
        ></iframe>
      }
    }
  }

  <!-- Self hosted video player -->
  @if (isInternalVideo(section)) {
    <kb-video
      [controls]="controls()"
      [appEditorId]="section.editorIds?.src"
      [src]="section.attributes.src"
      [poster]="section.attributes.thumbnailSrc"
      [crop]="section.attributes.align === 'centered' ? 'both' : section.attributes.align"
      [autoplay]="section.attributes.autoplay"
      [loop]="section.attributes.loop"
    ></kb-video>
  }
